import { render, staticRenderFns } from "./CheckFlow.vue?vue&type=template&id=f5322910&scoped=true"
import script from "./CheckFlow.vue?vue&type=script&lang=js"
export * from "./CheckFlow.vue?vue&type=script&lang=js"
import style0 from "./CheckFlow.vue?vue&type=style&index=0&id=f5322910&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5322910",
  null
  
)

export default component.exports